import { render, staticRenderFns } from "./ArticleProviderForm.vue?vue&type=template&id=c243d5fa&"
import script from "./ArticleProviderForm.vue?vue&type=script&lang=js&"
export * from "./ArticleProviderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports